import { z } from "zod";

import { basePrayerInCollectionSchema } from "../prayer/basePrayerInCollectionSchema";
import { baseCollectionSchema } from "./baseCollectionSchema";

export const collectionSchema = baseCollectionSchema.extend({
  prayers: z.array(
    basePrayerInCollectionSchema.omit({
      selectable_guides: true,
      order: true,
    }),
  ),
});

export type Collection = z.infer<typeof collectionSchema>;

export const defaultCollectionSchema = collectionSchema
  .omit({ type: true })
  .extend({
    type: z.literal("default"),
  });

export const challengeSchema = collectionSchema
  .omit({
    type: true,
  })
  .extend({
    type: z.literal("challenge"),
  });

export type Challenge = z.infer<typeof challengeSchema>;
